// extracted by mini-css-extract-plugin
export default {"VideosPage":"videospage_VideosPage__fippT","containerTop":"videospage_containerTop__wTV7B","title":"videospage_title__WCbT4","containerList":"videospage_containerList__tcsaO"};